import service from './src/index';

export default {
    install(Vue) {
        Vue.prototype.$dialogNotice = service;
    },
    service
}